export const STATE_PRIVACY_UPDATE = 'STATE_PRIVACY_UPDATE';
export const GPC_SIGNAL_STATUS = 'GPC_SIGNAL_STATUS';
export const GPC_SIGNAL_CHECK_COMPLETE = 'GPC_SIGNAL_CHECK_COMPLETE';

export type StatePrivacyUpdateActionType = {
    type: typeof STATE_PRIVACY_UPDATE;
    payload?: unknown;
}

export function statePrivacyUpdate(): StatePrivacyUpdateActionType {
    return {
        type: STATE_PRIVACY_UPDATE
    };
} 

export type GPCSignalCheckActionType = {
    type: typeof GPC_SIGNAL_CHECK_COMPLETE;
    payload?: unknown;
}

export function gpcSignalCheckAction(): GPCSignalCheckActionType {
    return {
        type: GPC_SIGNAL_CHECK_COMPLETE
    };
} 

export type GPCSignalStatusActionType = {
    type: typeof GPC_SIGNAL_STATUS;
    payload: boolean;
}

export function gpcSignalStatusAction(isEnabled: boolean): GPCSignalStatusActionType {
    return {
        type: GPC_SIGNAL_STATUS,
        payload: isEnabled
    };
} 
